import React from "react";
import TodoList from "../components/TodoList";

const Home = () => {
  return (
    <div>
      <TodoList />
    </div>
  );
};

export default Home;
